import React, { FC, Suspense } from 'react'
import FallbackUI from '../../components/FallbackUI'
import Footer from './Footer'
import Header, { HeaderProps } from './Header'
import CookieBanner from '../../components/CookieBanner';
// TODO: Delte props from layout
interface BaseLayoutProps {
  headerProps?: HeaderProps;
}

export const BaseLayout: FC<BaseLayoutProps> = ({ children, headerProps }) => {
  return (
    // <Suspense fallback={<FallbackUI />}>
    //   <Header {...headerProps} />
    //   {children}
    //   <Footer />
    // </Suspense>
    <>
      <Header {...headerProps} />
      <CookieBanner />
      {children}
      <Footer />
    </>
  )
}

export default BaseLayout
